import Vue       from "vue"
import gtag      from "vue-gtag"
import store     from "./store/"
import router    from "./router/"
import App       from './App.vue'

import "./polyfill"

Vue.config.productionTip = false
Vue.use(gtag, {
  config: { id: "UA-98374580-3" }
}, router)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
